import script from "./CatalogProductsBulkSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogProductsBulkSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogProductsBulkSearchInput.vue?vue&type=style&index=0&id=fd97a9c4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd97a9c4"]])

export default __exports__